var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5809 7.76364L12.6628 7.76364L10.1488 10.2777L11.2285 11.3574L15.5857 7.00018L11.2285 2.64298L10.1488 3.72269L12.6628 6.23671L4.5809 6.23671L4.5809 7.76364ZM1.52696 13.8713L8.39817 13.8713L8.39817 12.3444L1.52696 12.3444L1.52696 1.65584L8.39817 1.65584L8.39817 0.128906L1.52696 0.128906C0.683655 0.128906 2.28583e-05 0.812538 2.28214e-05 1.65584L2.23542e-05 12.3444C2.23174e-05 13.1877 0.683654 13.8713 1.52696 13.8713Z",
    fill: "#A8A8A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogout);
export default __webpack_public_path__ + "static/media/mobileLogout.42806518e7fe9746036cd8b0771c29de.svg";
export { ForwardRef as ReactComponent };